export enum MessageRole {
    System,
    User,
    Assistant,
    Tool,
}
